<template>
  <div>

    <v-dialog
      v-model="finished"
      width="350px"
    >
      <v-card
        flat
        class="pa-5"
      >
        <p>Budeme Vás kontaktovat nejpozději následující pracovní den, Vámi preferovaným způsobem. Nepoužíváme neosobní automaticky generované e-maily.</p>
        <div class="d-flex justify-center mt-5">
          <v-btn
            @click="finished = false"
            variant="flat"
            color="#227e40"
            size="large"
            class="text-white"
          >zavřít</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-form @submit.prevent="submit">

      <v-text-field
        :error-messages="getViolation('fullName')"
        label="jméno a příjmení"
        v-model="fullName"
        variant="outlined"
        density="compact"
      />

      <div class="grid-50-50">
        <v-text-field
          :error-messages="getViolation('email')"
          label="e-mail"
          v-model="email"
          type="email"
          variant="outlined"
          density="compact"
        />

        <v-text-field
          :error-messages="getViolation('phone')"
          label="telefon"
          v-model="phone"
          variant="outlined"
          density="compact"
        />
      </div>
      <v-text-field
        :error-messages="getViolation('companyName')"
        v-model="companyName"
        label="název firmy"
        variant="outlined"
        density="compact"
      />
      <div class="grid-50-50">
        <div class="mb-5">
          <strong>Mám zájem o</strong>
          <v-checkbox
            :error-messages="getViolation('interestedInProduct1')"
            :true-value="1"
            :false-value="0"
            label="Normované produkty"
            v-model="interestedInProduct1"
            hide-details
            density="compact"
          ></v-checkbox>
          <v-checkbox
            :error-messages="getViolation('interestedInProduct2')"
            :true-value="1"
            :false-value="0"
            label="Individuální řešení"
            v-model="interestedInProduct2"
            hide-details
            density="compact"
          ></v-checkbox>

          <v-checkbox
            :error-messages="getViolation('interestedInProduct3')"
            :true-value="1"
            :false-value="0"
            label="FLUID MANAGEMENT"
            v-model="interestedInProduct3"
            hide-details
            density="compact"
          ></v-checkbox>

          <v-checkbox
            :error-messages="getViolation('interestedInProduct4')"
            :true-value="1"
            :false-value="0"
            label="INSTANT CLEAN"
            v-model="interestedInProduct4"
            hide-details
            density="compact"
          ></v-checkbox>
        </div>
        <div class="mb-5">
          <strong>Preferuji komunikaci</strong>
          <v-checkbox
            :error-messages="getViolation('preferPhoneCommunication')"
            :true-value="1"
            :false-value="0"
            label="Telefonicky"
            v-model="preferPhoneCommunication"
            hide-details
            density="compact"
          ></v-checkbox>
          <v-checkbox
            :error-messages="getViolation('preferEmailCommunication')"
            :true-value="1"
            :false-value="0"
            label="E-mail"
            v-model="preferEmailCommunication"
            hide-details
            density="compact"
          ></v-checkbox>
        </div>
      </div>
      <v-textarea
        :error-messages="getViolation('message')"
        placeholder="Pokud si nejste jisti, jaký produkt je ten pravý pro Vás, či máte jiné dotazy."
        v-model="message"
        variant="outlined"
        density="compact"
      />

      <!-- Honeypot: hidden off-screen; real users never fill it, bots that fill every input do. -->
      <div
        style="position:absolute;left:-9999px;top:-9999px;"
        aria-hidden="true"
      >
        <label>Website<input
          v-model="website"
          type="text"
          name="website"
          tabindex="-1"
          autocomplete="off"
        ></label>
      </div>

      <div class="d-flex justify-center">
        <v-btn
          :loading="loading"
          :disabled="loading"
          type="submit"
          variant="flat"
          color="#227e40"
          size="large"
          class="text-white"
        >odeslat</v-btn>
      </div>
    </v-form>

  </div>
</template>
<script>
import Axios from '../ajax'
import Qs from 'qs'
import { errorMixin } from '../mixins/error-mixin'

export default {
  name: 'VContactForm',
  mixins: [
    errorMixin
  ],
  data () {
    return {
      loading: false,
      finished: false,
      fullName: null,
      email: null,
      phone: null,
      message: null,
      companyName: null,
      website: null,
      preferPhoneCommunication: false,
      preferEmailCommunication: false,
      interestedInProduct1: false,
      interestedInProduct2: false,
      interestedInProduct3: false,
      interestedInProduct4: false,
    }
  },
  methods: {
    async submit () {
      // A second click or Enter while the request runs would send a duplicate inquiry.
      if (this.loading) return
      this.loading = true
      try {
        this.clearViolations()
        await Axios.post('/kontakt', Qs.stringify({
          fullName: this.fullName,
          email: this.email,
          phone: this.phone,
          message: this.message,
          companyName: this.companyName,
          website: this.website,
          preferPhoneCommunication: this.preferPhoneCommunication,
          preferEmailCommunication: this.preferEmailCommunication,
          interestedInProduct1: this.interestedInProduct1,
          interestedInProduct2: this.interestedInProduct2,
          interestedInProduct3: this.interestedInProduct3,
          interestedInProduct4: this.interestedInProduct4,
        }))

        this.loading = false
        this.finished = true
        this.fullName = null
        this.email = null
        this.phone = null
        this.message = null
        this.companyName = null
        this.preferPhoneCommunication = false
        this.preferEmailCommunication = false
        this.interestedInProduct1 = false
        this.interestedInProduct2 = false
        this.interestedInProduct3 = false
        this.interestedInProduct4 = false
      } catch (err) {
        this.loading = false
        this.buildViolations(err.response)
      }
    }
  }
}
</script>
